<template>
  <div class="mt-5">
    <div class="row pt-4">
      <div class="col-xs-12 col-sm-6 col-md-3 pb-5 text-capitalize">
        <h5>ayancık adak</h5>
        <hr />
        <h2>Sinop Ayancık her bütçeye uygun kurbanlık ve adaklık</h2>
        <br />
        <h2>
          İslami usullere göre kurbanınızı kesiyor ve sizlere ulaştırıyoruz.
        </h2>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3 pb-5">
        <h5>Hızlı Lİnk</h5>
        <hr />
        <ul>
          <router-link
            v-for="item in menus"
            :key="item.id"
            :to="item.router_to"
          >
            <a>
              <li>{{ item.menu_ad | upperCase }}</li>
            </a>
          </router-link>
        </ul>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-3 pb-5">
        <h5>Etİketler</h5>
        <hr />
        <h1>
          <a
            href="https://www.ayancikadak.com"
            v-for="(tag, i) in tags"
            :key="i"
          >
            {{ tag }}</a
          >
        </h1>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-3 pb-5">
        <h5>İletİşİm</h5>
        <hr />
        <p class="text-center">
          <i class="fas fa-map-marker-alt"></i> {{ adress }}
        </p>
        <p class="text-center">
          <i class="fas fa-mobile-alt"></i>
          <a href="https://wa.me/905326158788" target="_blank">
            {{ phoneNumber1 }}
          </a>

          <span>/</span>

          <a href="https://wa.me/905362072458" target="_blank">
            {{ phoneNumber2 }}
          </a>
        </p>
        <div class="container text-center mb-5">
          <a
            :href="item.href"
            v-for="item in socialMedia"
            :key="item.id"
            target="_blank"
          >
            <i :class="item.icon"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="row copyright pt-2">
      <div class="col-md-12">
        <p class="text-center" style="color: #969696 !important">
          Copyright Ayancık Adak © {{ date }}. Tüm hakları saklıdır. |
          <span
            class="fas fa-laptop-code"
            style="font-size: 20px; color: white"
          ></span>
          by
          <a target="_blank" href="https://tr.linkedin.com/in/kaansen57"
            >Kaan
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import json from "../menus.json";
export default {
  data() {
    return {
      date: new Date().getFullYear().toString(),
      menus: json,
      adress: "Adres : Ayancık / Sinop",
      phoneNumber1: "+90 532 615 8788",
      phoneNumber2: "+90 536 207 2458",
      socialMedia: [
        {
          id: 1,
          href: "https://fb.com/ayancikadak",
          icon: "fab fa-facebook-f",
        },
        {
          id: 2,
          href: "https://www.instagram.com/ergin7548/",
          icon: "fab fa-instagram",
        },
        { id: 3, href: "https://wa.me/905326158788", icon: "fab fa-whatsapp" },
      ],
      tags: [
        "Ayancık Adak,",
        "Sinop Kurbanlık,",
        "Sinop Kurbanlık Satış,",
        "Ayancık Kurbanlık,",
        "Sinop Adaklık,",
        "Ayancık Adaklık,",
        "Ayancık Koyun Satış,",
        "Sinop Koyun Satış",
      ],
    };
  },
  filters: {
    upperCase(value) {
      if (!value) return "";
      return value.toString().toUpperCase();
    },
  },
};
</script>

<style scoped>
.row {
  background-color: #333;
}
.copyright {
  background-color: #2b2b2b !important;
}
a {
  color: white;
}
a:hover {
  text-decoration: none;
  color: white;
}
h5 {
  color: white;
  text-transform: uppercase;
}
hr {
  background-color: white;
}
p {
  color: white;
  font-size: 15px;
}
h2,
h1 {
  color: white;
  font-size: 15px;
}
i {
  color: white;
  font-size: 25px;
  transition: transform 1s ease;
  padding: 0;
  margin-left: 20px;
}
i:hover {
  transform: rotate(360deg);
  transition: transform 1s ease;
}
ul {
  padding: 0;
  display: block;
  float: left;
}
ul a {
  text-decoration: none;
  color: white;
}
ul a:hover {
  text-decoration: none;
  color: #3aa37d;
}
ul a li {
  list-style-type: none;
  font-size: 15px;
  margin-bottom: 10px;
}
@media screen and (max-width: 768px) {
  h5 {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue